﻿import {currentCulture, TimeOnly} from "@2d-front-monorepo/core";

export function formatTime(time: TimeOnly): string {
	return currentCulture().formatTime(time, "short-time");
}
